import { c as _c } from "react/compiler-runtime";
import { ArrowContainer, Popover, PopoverPosition, PopoverState } from 'react-tiny-popover';
import { ReactElement, ReactNode, memo } from 'react';
import classNames from 'clsx';
import styles from './popover.component.module.scss';
export enum PopoverPositions {
  TOP = 'top',
  RIGHT = 'right',
  LEFT = 'left',
  BOTTOM = 'bottom',
}
export interface Props {
  readonly children: ReactNode;
  readonly contents: ReactNode;
  readonly isInFlyout?: boolean;
  readonly isPopoverOpen: boolean;
  readonly onClosed: () => void;
  readonly positions?: Array<PopoverPositions>;
}
function PopoverComponent(t0) {
  const $ = _c(13);
  const {
    children,
    contents,
    isInFlyout,
    isPopoverOpen,
    onClosed,
    positions
  } = t0;
  const getArrowClassName = _temp;
  let t1;
  if ($[0] !== isInFlyout) {
    t1 = classNames(styles.popover, {
      [styles["popover--flyout"]]: isInFlyout
    });
    $[0] = isInFlyout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== positions) {
    t2 = positions ?? Object.values(PopoverPositions);
    $[2] = positions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== contents) {
    t3 = t4 => {
      const {
        childRect,
        popoverRect,
        position: position_0
      } = t4;
      return <ArrowContainer arrowClassName={getArrowClassName(position_0)} arrowColor="white" arrowSize={12} childRect={childRect} popoverRect={popoverRect} position={position_0}><div className={styles.popover__content}>{contents}</div></ArrowContainer>;
    };
    $[4] = contents;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== isPopoverOpen || $[8] !== onClosed || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <Popover containerClassName={t1} isOpen={isPopoverOpen} onClickOutside={onClosed} positions={t2} content={t3}>{children}</Popover>;
    $[6] = children;
    $[7] = isPopoverOpen;
    $[8] = onClosed;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(position) {
  return classNames(styles.popover__arrow, {
    [styles[`popover__arrow--from-${position}`]]: position
  });
}
export default memo(PopoverComponent);